<template>
  <div class="result">
    <div class="result__header">
      <div class="result__header__subtitle subhead">
        Showing result for :
      </div>
      <h1 class="result__header__title large-title">
        “{{this.searchValue}}”
      </h1>
      <p class="result__header__total">
        Total listing 1.800 items
      </p>
    </div>
    <div class="result__subheader">
      <adx-breadcrumb />
    </div>
    <div class="result__content">
      <div class="result__content__listings">
        <div class="result__content__listings__filter">
          <div class="result__content__listings__filter__left">
            <adx-dropdown-search class="dropdownDoc__item" @selected="selectedSearch" :list="search"
            labelButton="Locations" :selected-value="selectedSearchValue"/>
            <adx-dropdown-checkbox class="dropdownDoc__item" @selected="selected" :list="checkbox" labelButton="Brands" />
            <adx-dropdown-list class="dropdownDoc__item" @selected="selected" :list="list" labelButton="Package" />
          </div>
          <div class="result__content__listings__filter__right">
            <adx-dropdown-sort :type="true" :label="`Select sort`" :options="list" />
          </div>
        </div>
        <!-- <adx-list-group :items='items' :headers='headers' /> -->
      </div>
      <div class="result__content__filter">
        <adx-quick-filter :list="cities" :value.sync="selectedCityValue" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import QuickFilter from '@/components/QuickFilter'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'

export default {
  name: 'adx-results-group',
  components: {
    'adx-quick-filter': QuickFilter,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-sort': DropdownSort,
    'adx-breadcrumb': Breadcrumb
  },
  props: {

  },
  data() {
    return {
      items: [],
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      cities: [ 
        { 
          "id": 0, 
          "label": "All", 
          "value": "" 
        }, 
        { 
          "id": 1, 
          "label": "Jakarta Utara", 
          "value": 1 ,
          "subitem": [
            {
              "id": 0,
              "label": "Jakarta"
            },
            {
              "id": 1,
              "label": "Jakarta"
            },
            {
              "id": 2,
              "label": "Jakarta"
            }
          ]
        }, 
        { 
          "id": 2, 
          "label": "Jakarta Selatan", 
          "value": 2 
        }, 
        { 
          "id": 3, 
          "label": "Jakarta Barat", 
          "value": 3 
        }, 
        { 
          "id": 4, 
          "label": "Jakarta Pusat", 
          "value": 4 
        } 
      ],
      selectedCityValue: ``,
      search: [
        {
          'id': 0,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 0,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 1,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 2,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 3,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 4,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 5,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 6,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 7,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 8,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 9,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
        {
          'id': 1,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 10,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 11,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 12,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 13,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 14,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 15,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 16,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 17,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 18,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 19,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
        {
          'id': 2,
          'title': 'West Jakarta',
          'locations': [
            {
              'id': 20,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 21,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 22,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 23,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 24,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
            {
              'id': 25,
              'location': 'Kemanggisan',
              'detail': 'Jakarta Pusat',
            },
            {
              'id': 26,
              'location': 'Kemayoran',
              'detail': 'Jakarta Utara'
            },
            {
              'id': 27,
              'location': 'Ancol',
              'detail': 'Jakarta Timur'
            },
            {
              'id': 28,
              'location': 'Grogol',
              'detail': 'Jakarta Barat'
            },
            {
              'id': 29,
              'location': 'Kemang',
              'detail': 'Jakarta Selatan'
            },
          ]
        },
      ],
      checkbox: [
        {
          'id': 0,
          'label': 'Bebek Kaleyo',
          'value': 'BK',
        },
        {
          'id': 1,
          'label': 'Laus Kopi',
          'value': 'LK'
        },
        {
          'id': 2,
          'label': 'Upnormal',
          'value': 'UP'
        },
        {
          'id': 3,
          'label': 'Abuba',
          'value': 'AB'
        },
        {
          'id': 4,
          'label': 'Concordia',
          'value': 'CO'
        },
      ],
      list: [
        {
          'id': 0,
          'label': 'Gaul',
          'value': 'GA',
        },
        {
          'id': 1,
          'label': 'Jadul',
          'value': 'JA'
        },
        {
          'id': 2,
          'label': 'Konser',
          'value': 'KO'
        },
        {
          'id': 3,
          'label': 'Nobar',
          'value': 'NO'
        },
        {
          'id': 4,
          'label': 'Seminar',
          'value': 'SE'
        },
      ],
      selectedSearchValue: '',
      searchValue: ``
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData();
    this.searchValue = this.$route.query.search
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      let file = `/static/data/list.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();
        
        this.items = data.items;
      })();
    },
    selected(item){
      
    },
    selectedSearch(item){
      this.selectedSearchValue = item.id.toString()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>